import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const VehicleFleet = () => {

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <div className="section-full p-t150 p-b120 site-bg-light twm-vehicle-fleet2-wrap wow fadeInDown">
      <div className="container">

        {/* Title */}
        <div className="section-head center">
          <div className="twm-sm-title left">Choose your car</div>
          <h2 className="twm-large-title site-text-dark">Our Vehicle Fleet</h2>
        </div>

        <div className="section-content">

          <Slider {...settings} className="twm-vehicle-fleet2-carousel">

            {/* Item 1 */}
            <div className="item">
              <div className="twm-vehicle-fleet-large-bx">
                
                <div className="twm-media">
                  <div className="twm-media-pic">
                    <img src="/images/large-v-fleet/pic1.jpg" alt="image" />
                  </div>
                </div>

                <div className="twm-vehicle-fleet-content">

                  <div className="twm-price-section">
                    <div className="v-price">$800</div>
                    <div className="v-duration">/ Day</div>
                  </div>

                  <h3 className="twm-v-title">
                    <a href="#">Lamborghini</a>
                  </h3>

                  <ul className="twm-vehicle-facility">
                    <li>
                      <span>
                        <img src="/images/icons/car-seat.png" alt="" />
                      </span>
                      4 Seat
                    </li>
                    <li>
                      <span>
                        <img src="/images/icons/bag.png" alt="" />
                      </span>
                      4 Bags
                    </li>
                    <li>
                      <span>
                        <img src="/images/icons/car.png" alt="" />
                      </span>
                      Exotic car
                    </li>
                  </ul>

                  <ul className="twm-vehicle-fuel-type">
                    <li>Petrol</li>
                    <li><del>Diesel</del></li>
                    <li><del>Electric</del></li>
                  </ul>

                </div>
              </div>
            </div>

            {/* Item 2 */}
            <div className="item">
              <div className="twm-vehicle-fleet-large-bx">

                <div className="twm-media">
                  <div className="twm-media-pic">
                    <img src="/images/large-v-fleet/pic2.jpg" alt="image" />
                  </div>
                </div>

                <div className="twm-vehicle-fleet-content">

                  <div className="twm-price-section">
                    <div className="v-price">$800</div>
                    <div className="v-duration">/ Day</div>
                  </div>

                  <h3 className="twm-v-title">
                    <a href="#">Jeep Renegade</a>
                  </h3>

                  <ul className="twm-vehicle-facility">
                    <li>
                      <span>
                        <img src="/images/icons/car-seat.png" alt="" />
                      </span>
                      4 Seat
                    </li>
                    <li>
                      <span>
                        <img src="/images/icons/bag.png" alt="" />
                      </span>
                      4 Bags
                    </li>
                    <li>
                      <span>
                        <img src="/images/icons/car.png" alt="" />
                      </span>
                      Exotic car
                    </li>
                  </ul>

                  <ul className="twm-vehicle-fuel-type">
                    <li>Petrol</li>
                    <li><del>Diesel</del></li>
                    <li><del>Electric</del></li>
                  </ul>

                </div>
              </div>
            </div>

            {/* Item 3 */}
            <div className="item">
              <div className="twm-vehicle-fleet-large-bx">

                <div className="twm-media">
                  <div className="twm-media-pic">
                    <img src="/images/large-v-fleet/pic3.jpg" alt="image" />
                  </div>
                </div>

                <div className="twm-vehicle-fleet-content">

                  <div className="twm-price-section">
                    <div className="v-price">$800</div>
                    <div className="v-duration">/ Day</div>
                  </div>

                  <h3 className="twm-v-title">
                    <a href="#">Chevrolet Coupe</a>
                  </h3>

                  <ul className="twm-vehicle-facility">
                    <li>
                      <span>
                        <img src="/images/icons/car-seat.png" alt="" />
                      </span>
                      4 Seat
                    </li>
                    <li>
                      <span>
                        <img src="/images/icons/bag.png" alt="" />
                      </span>
                      4 Bags
                    </li>
                    <li>
                      <span>
                        <img src="/images/icons/car.png" alt="" />
                      </span>
                      Exotic car
                    </li>
                  </ul>

                  <ul className="twm-vehicle-fuel-type">
                    <li>Petrol</li>
                    <li><del>Diesel</del></li>
                    <li><del>Electric</del></li>
                  </ul>

                </div>
              </div>
            </div>

          </Slider>

        </div>

      </div>
    </div>
  );
};

export default VehicleFleet;